import { useDeclaredHolidays } from "@core";
import type { PublicHoliday } from "@core";

import { supabase } from "./supabase";

/**
 * Days that were proclaimed rather than computed.
 *
 * The twelve the Public Holidays Act fixes, and the Monday after one that falls
 * on a Sunday, are worked out in core/holidays. An election day is not: somebody
 * declares it, and no rule produces it.
 *
 * Handed to core once, which every rule that prices a day then falls back to —
 * see useDeclaredHolidays for why that is a registry rather than an argument
 * threaded through every call site.
 *
 * No cache here, unlike the phone. A browser that cannot reach Supabase cannot
 * show a register either, so there is nothing to keep working offline for.
 */
export async function loadDeclaredHolidays(country = "ZA"): Promise<void> {
  const { data, error } = await supabase
    .from("declared_holidays")
    .select("date, name")
    .eq("country_code", country)
    .order("date");

  // Leave whatever is loaded alone on failure. Replacing it with an empty list
  // would quietly stop paying for a declared day.
  if (error || !data) return;

  useDeclaredHolidays(
    (data as Record<string, any>[]).map((r) => ({ date: r.date, name: r.name }) as PublicHoliday),
  );
}
